module.exports = __webpack_public_path__ + "static/media/xo-list.102ec10c.png";